<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MITs -->
<div style="position: relative;width:100%;height: 100%;">
    <canvas #chartCanvas  ></canvas>
</div>
